import(/* webpackMode: "eager" */ "/app/src/app/(STATIC)/dsmi/page.tsx");
